module.exports = __webpack_public_path__ + "static/media/kudu2.37cfa226.mp4";